import { render, staticRenderFns } from "./Telegram.vue?vue&type=template&id=57d108ec&scoped=true&"
import script from "./Telegram.vue?vue&type=script&lang=js&"
export * from "./Telegram.vue?vue&type=script&lang=js&"
import style0 from "./Telegram.vue?vue&type=style&index=0&id=57d108ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d108ec",
  null
  
)

export default component.exports